<ng-container *ngIf="languageSelected$ | async"> </ng-container>
<select class="language-select" [formControl]="languageControl">
  <option
    class="language-option"
    *ngFor="let language of languageOptions"
    [ngValue]="language.code">
    {{ language.display }}
  </option>
</select>
